import { ReactNode, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import { ModalContainer } from './ModalContainer';
import { UploadEmpresaFileForm } from './UploadEmpresaFIleForm';
import { DownloadImportTemplateButton } from './DownloadImportTemplateButton';
import { ExportVisitsButton } from 'src/features/visitas/ExportVisits/ExportVisitsButton';
import { ExportVisitsForm } from 'src/features/visitas/ExportVisits/ExportVisitsForm';
import { useSelector } from 'react-redux';
import { selectCurrentUserRole } from 'src/api/auth/authSlice';
import { ROLES } from 'src/utils/enums';
import { ModalWindowContainer } from '../ui/ModalWindowContainer';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import { UploadEmpresaFileButton } from './UploadEmpresaFileButton';

export function UploadEmpresaButton() {
    const userRole = useSelector(selectCurrentUserRole);

    const [openModal, setOpenModal] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef<HTMLDivElement>(null);
    const modalRef = useRef<HTMLDivElement>(null);
    const [modalPosition, setModalPosition] = useState<{ top: number; left: number; }>({
        top: 0,
        left: 0,
    });

    const [currentComponent, setCurrentComponent] = useState<ReactNode | null>(null);

    const toggleModal = () => {
        if(buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setModalPosition({
                top: rect.bottom + window.scrollY + 2,
                left: rect.left + window.scrollX - 0,
            });
        }

        setIsOpen(!isOpen);
    }

    const handleClickOutside = (event: MouseEvent) => {
        if(modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        buttonRef.current && 
        !buttonRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    }

    const handleCloseModal = () => setOpenModal(false);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    return (
        <>
        <div className="bg-green-800 h-[30px] flex rounded">
            <Link to={"/empresa/nueva"}>
                <button className="bg-green-800 h-[30px] w-[90px] rounded px-[6px] py-[4px] flex gap-1 items-center">
                    <AddRoundedIcon sx={{ height: 15, width: 15, color: "white" }}/>
                    <p className="text-white text-[13px] font-semibold">Empresa</p>
                </button>
            </Link>
            <div
                className="flex justify-center items-center border-l border-gray-400 px-[4px] py-[2px] cursor-pointer"
                ref={buttonRef}
                onClick={toggleModal}>
                <div className={`flex justify-center items-center ${isOpen ? "-rotate-90" : "rotate-90"} transition-all duration-100`}>
                    <PlayArrowRoundedIcon sx={{ height: 15, width: 15, color: "white" }}/>
                </div>
            </div>

            {isOpen && (
                <div
                ref={modalRef}
                className="absolute bg-white shadow-lg border border-gray-300 rounded p-2 z-50 w-64"
                style={{ top: modalPosition.top, left: modalPosition.left }}>

                    {/* <div */}
                    {/*     onClick={() => { */}
                    {/*         setCurrentComponent( */}
                    {/*             <UploadEmpresaFileForm onClose={handleCloseModal}/>); */}
                    {/*         setOpenModal(true); */}
                    {/*         setIsOpen(false); */}
                    {/*     }} */}
                    {/*     className="flex gap-x-1 items-center hover:bg-gray-200 rounded-[3px] py-[6px] cursor-pointer mb-2 px-[10px]"> */}
                    {/*     <FileUploadRoundedIcon sx={{ height: 20, width: 20 }}/> */}
                    {/*     <p className="text-sm font-semibold text-center ">Subir excel</p> */}
                    {/* </div> */}

                    <UploadEmpresaFileButton onClick={handleCloseModal} />

                    {userRole == ROLES.ADMIN && (
                    <ExportVisitsButton
                        onClick={() => {
                            setCurrentComponent(<ExportVisitsForm onClose={handleCloseModal}/>)
                            setOpenModal(true);
                            setIsOpen(false);
                        }}/>
                    )}

                    <div className="border-t border-gray-400 rounded-full mt-2"></div>

                    <DownloadImportTemplateButton />
                </div>
            )}
        </div>

        {openModal && (
        <ModalContainer>
            <ModalWindowContainer onClose={handleCloseModal}>
                {currentComponent}
            </ModalWindowContainer>
        </ModalContainer>
        )}
        </>
    );
}
